<div class="d-flex p-3 border-bottom bg-gray-200 hover-bg-white cursor-pointer">
  <div>
    <div class="d-flex position-relative me-3">
      <ng-content select="[notification-icon]" />
      @if (showBadge) {
        <span class="position-absolute rounded-circle bg-primary abstract-notification-badge"></span>
      }
    </div>
  </div>
  <div class="d-flex flex-column flex-nowrap">
    <span class="color-black"><ng-content select="[notification-title]" /></span>
    <span class="small color-gray-600"><ng-content select="[notification-text]" /></span>
    <span class="small color-gray"><ng-content select="[notification-subtext]" /></span>
    <ng-content />
  </div>
</div>
